import {FC} from "react";
import {BottomSheet} from "../../container/ModalSheet.tsx";
import {Heading} from "../../ui-components/heading.tsx";
import {Button} from "../../ui-components/button.tsx";
import {ToastContainer} from "react-toastify";
import {useModalClose} from "../../hooks/modal/useCloseModal.ts";
import {useTranslation} from "react-i18next";

export const DeclinePublicationModal: FC<{
    isOpen: boolean;
    modalId: string,
    onClose: () => void;
}> = ({
          isOpen,
          onClose,
          modalId
      }) => {
    const closeManually = useModalClose(modalId);
    const {t} = useTranslation();
    return (
        <BottomSheet isOpen={isOpen} onClose={closeManually}>
            <div className="w-full px-4 flex flex-col items-center relative overflow-hidden">
                <ToastContainer className={'ToastContainer'} containerId={'publication_details_id'}
                                style={{top: "23px"}}/>
                <div className="w-10 h-0.5 bg-[var(--color-line)] my-2"></div>
                <Heading level={2} className={"text-2xl text-center mb-4 mt-4"}>
                    {t('modals.declinePublication.heading')}
                </Heading>
                <p className="!text-sm text-center text-[var(--color-secondary-2)] mb-6">
                    {t('modals.declinePublication.desc')}
                </p>
                <div className="w-full flex gap-6">
                    <Button color={"white"}
                            className="w-full !bg-white !py-2.5 rounded-lg !border !border-[var(--btn-border-custom)] shadow-xs !text-sm !leading-5"
                            onClick={closeManually}>
                        {t('common.buttons.cancel')}
                    </Button>
                    <Button color={"cyan"}
                            onClick={onClose}
                            className="w-full !py-2.5 rounded-lg !bg-[var(--color-red)] before:bg-transparent text-white !text-sm !leading-5">
                        {t('common.buttons.completeBtn')}
                    </Button>
                </div>
            </div>
        </BottomSheet>
    );
};
